import NavVisitsPanel from './NavVisitsPanel.vue';
import NavCartPanel from './NavCartPanel.vue';
import NavNotificationsPanel from './NavNotificationsPanel.vue';

// Panels of the legacy nav bar (visit-preview, cartpreview, notification components), with the
// labels the legacy bottom bar shows (nav.js setItemMenuLabels).
export const NAV_PANELS = {
	visits: { icon: 'store', labelKey: 'Visits', component: NavVisitsPanel },
	cart: { icon: 'shopping_cart', labelKey: 'Orders', component: NavCartPanel },
	notifications: { icon: 'notifications', labelKey: 'Notifications', component: NavNotificationsPanel },
};

// Legacy order: visits, cart, notifications on the desktop bar; cart, visits, notifications on the mobile one.
export const DESKTOP_PANEL_ORDER = ['visits', 'cart', 'notifications'];
export const MOBILE_PANEL_ORDER = ['cart', 'visits', 'notifications'];
